import React from 'react';
import { createGlobalStyle } from 'styled-components';
import { white } from '../../design-system/variables/colors';
import { spaceBase, spaceLarge } from '../../design-system/variables/spaces';
import { md } from '../../design-system/media-queries';
import { Icon } from '../Icon';

const GlobalStyle = createGlobalStyle`
 .responsive-footer__social-icons-container {
	    width: 100%;
		max-width: 217px;
		margin: 0 auto ${spaceLarge} auto;

		${md`
			margin-bottom: ${spaceBase};
		`}

		.row {
			flex-wrap: nowrap;
		}
	}

 .responsive-footer__social-icons {
		padding: 0;
 }

	.responsive-footer__social-icon {
		display: flex;
    	justify-content: center;
		fill: ${white};
		line-height: 0;
	}

.x-icon, .linkedIn-icon {
	height: 24px;
}
`;

export const SocialMedia: React.FC = () => (
	<div className='col-xs-12'>
		<GlobalStyle />
		<div className='responsive-footer__social-icons-container'>
			<div className='row center-xs'>
				<div className='col-xs responsive-footer__social-icons'>
					<a
						className='responsive-footer__social-icon'
						href='https://www.instagram.com/inspirato/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Icon iconName='instagram' iconSize='md' />
					</a>
				</div>
				<div className='col-xs responsive-footer__social-icons'>
					<a
						className='responsive-footer__social-icon'
						href='https://www.facebook.com/Inspirato/'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Icon iconName='facebook' iconSize='md' />
					</a>
				</div>
				<div className='col-xs responsive-footer__social-icons'>
					<a
						className='x-icon responsive-footer__social-icon'
						href='https://www.x.com/Inspirato'
						target='_blank'
						rel='noopener noreferrer'
					>
						<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
							<path
								className='ds-shape-primary'
								d="M13.9027 10.4351L21.3482 1.78033H19.5838L13.119 9.29512L7.95547 1.78033H2L9.8082 13.144L2 22.2198H3.76443L10.5915 14.284L16.0445 22.2198H22L13.9027 10.4351ZM4.40018 3.10857H7.11025L19.5847 20.952H16.8746L4.40018 3.10857Z"
							/>
						</svg>
					</a>
				</div>
				<div className='col-xs responsive-footer__social-icons'>
					<a
						className='linkedIn-icon responsive-footer__social-icon'
						href='https://www.linkedin.com/company/inspirato'
						target='_blank'
						rel='noopener noreferrer'
					>
						<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>
							<path
								className='ds-shape-primary'
								d="M22.13 23.69H1.69C0.920001 23.66 0.230001 22.96 0.220001 22.19V1.84C0.230001 1.03 0.980001 0.309997 1.79 0.329997H21.99C22.91 0.309997 23.62 1.15 23.65 2.04V22.07C23.59 22.85 22.95 23.69 22.12 23.69H22.13ZM5.19 3.59C3.65 3.75 2.9 5.62 3.88 6.83C4.86 8.04 6.88 7.68 7.33 6.18C7.76 4.77 6.64 3.44 5.19 3.59ZM20.09 20.21V13.24C19.98 11.16 19.37 9.33 17.09 8.93C15.58 8.66 13.95 8.93 12.97 10.21C12.89 10.31 12.78 10.54 12.73 10.6C12.69 10.64 12.67 10.63 12.63 10.63V9.13H9.33V20.22H12.78V14.24C12.86 12.99 13.28 11.93 14.68 11.86C16.17 11.78 16.6 12.78 16.68 14.09V20.22H20.1L20.09 20.21ZM7.15 9.12H3.73V20.21H7.15V9.12Z"
							/>
						</svg>
					</a>
				</div>
				<div className='col-xs responsive-footer__social-icons'>
					<a
						className='responsive-footer__social-icon'
						href='https://www.youtube.com/user/Inspiratodotcom'
						target='_blank'
						rel='noopener noreferrer'
					>
						<Icon iconName='youtube' iconSize='md' />
					</a>
				</div>
			</div>
		</div>
	</div>
);
